// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxList from '../../checkbox-list-with-label/checkbox-list';
import {FormattedMessage} from 'react-intl';

function isAllSelected(state, list, valueKey) {

    return list.every(option => state[option[valueKey]]);

}

function getSelectDeselectLabel(initialState) {

    return Object.keys(initialState).length ?
        'DESELECT_ALL' :
        'SELECT_ALL';

}

function handleToggleAll(props) {

    const toggleSelections = !isAllSelected(props.initialState, props.list, props.valueKey);

    props.onToggleAll(
        {
            isEverythingSelected: toggleSelections,
            uid: props.valueKey
        }
    );

}

const CheckboxFilterBody = props =>
    <section className='checkbox-filter-body'>
        <CheckboxList
            initialState={props.initialState}
            list={props.list}
            onChange={props.onChange}
            uid={props.valueKey}
        />
        {
            props.list.length < props.minNumberOfItems ?
                null :
                <button
                    className='btn-link'
                    onClick={handleToggleAll.bind(null, props)}
                >
                    <FormattedMessage id={getSelectDeselectLabel(props.initialState, props.list, props.valueKey)}/>
                </button>
        }
    </section>;

CheckboxFilterBody.displayName = 'CheckboxFilterBody';
CheckboxFilterBody.propTypes = {
    initialState: PropTypes.object.isRequired,
    list: PropTypes.array.isRequired,
    minNumberOfItems: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    onToggleAll: PropTypes.func.isRequired,
    valueKey: PropTypes.string.isRequired
};

export default CheckboxFilterBody;



// WEBPACK FOOTER //
// ./src/shared/components/facets/checkbox-filter/checkbox-filter-body.js